import { useQuery, UseQueryOptions } from 'react-query';
import { gql } from '@apollo/client';
import { useFDMApolloClient } from './useGraphQL';

const projectKey = (
  id: string,
  query: string,
  variables: any,
  headers: any
) => [`project/${id}/data`, query, variables, headers];

export const useProjectData = <T = any>(
  schemaCollectionRefId: string,
  query: string,
  variables: any = undefined,
  headers?: Record<string, string>,
  config: UseQueryOptions<T> = {}
) => {
  const client = useFDMApolloClient(schemaCollectionRefId, headers);

  return useQuery<T>(
    projectKey(schemaCollectionRefId, query, variables, headers),
    async () => {
      const response = await client.query<T>({
        query: gql(query),
        variables,
      });

      if (response.error) {
        throw response.errors;
      }

      return response.data;
    },
    config
  );
};
